<template>
    <SfSection
        class="section--form"
        section-width="content"
        data-scroll-id="form"
    >
        <template #default>
            <div v-if="formObject">
                <FormieForm
                    :form-handle="formObject.handle"
                    :locale="locale"
                />
            </div>
        </template>
    </SfSection>
</template>

<script setup>
import SfSection from '~/patterns/organisms/section/section';

const { locale } = useI18n();

const props = defineProps({
    block: {
        type: [Object, Array],
        required: true,
    },
});

const { block } = toRefs(props);

const formObject = computed(() => {
    // check if form is array or object, if array returns first item else return Object
    return Array.isArray(block.value.form) ? block.value?.form[0] : block.value.form;
});
</script>
